export const CommonSvg = {
  eyeIcon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7Z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  ),
  directSvg: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="110"
      height="25"
      viewBox="0 0 110 25"
      fill="none"
    >
      <path
        d="M56.4726 21.4498L56.1674 21.7536C54.7024 23.2728 52.688 24.0628 50.5515 24.0628C48.4151 24.0628 46.4007 23.212 44.8746 21.7536C43.3486 20.2345 42.433 18.2899 42.433 16.1631C42.3719 14.0363 43.1655 12.031 44.6305 10.5118C47.6826 7.41273 52.749 7.41273 55.9232 10.5118L56.2284 10.8157L54.7634 12.3348L54.3972 12.031C52.0165 9.72186 48.293 9.72186 46.0955 12.031C44.9967 13.1248 44.4473 14.5832 44.5084 16.1631C44.5694 17.743 45.1799 19.2014 46.3396 20.2952C47.4994 21.389 48.9644 21.9967 50.5515 21.9967C52.1386 21.9967 53.6036 21.389 54.6413 20.2952L54.9465 19.9914L56.4726 21.4498Z"
        fill="white"
      />
      <path
        d="M66.1137 8.20312C61.7187 8.20312 58.1172 11.7276 58.1172 16.1028C58.1172 20.478 61.7187 24.0024 66.1137 24.0024C70.5087 24.0024 74.0491 20.478 74.0491 16.1028C74.0491 11.7276 70.4476 8.20312 66.1137 8.20312ZM66.1137 21.8756C62.8785 21.8756 60.2537 19.2626 60.2537 16.1028C60.2537 12.9429 62.8785 10.33 66.1137 10.33C69.3489 10.33 71.9737 12.9429 71.9737 16.1028C71.9127 19.2626 69.2878 21.8756 66.1137 21.8756Z"
        fill="white"
      />
      <path d="M77.9533 0H76V24.0028H77.9533V0Z" fill="white" />
      <path
        d="M109.997 8.08196V10.0265H106.517V24.0028H104.625V0H106.517V8.08196H109.997Z"
        fill="white"
      />
      <path
        d="M39.6838 12.9412C39.3175 11.9689 38.7071 11.179 38.0357 10.4498C37.3032 9.72056 36.5096 9.17366 35.533 8.74829C34.5563 8.32292 33.5186 8.14062 32.3588 8.14062C31.26 8.14062 30.2223 8.32292 29.2456 8.74829C28.269 9.17366 27.4144 9.72056 26.7429 10.4498C26.0104 11.179 25.461 11.9689 25.0948 12.9412C24.6675 13.9134 24.4844 14.8857 24.4844 15.9795C24.4844 17.0733 24.6675 18.1063 25.0948 19.0786C25.5221 20.0509 26.0715 20.9016 26.804 21.6308C27.5365 22.36 28.3911 22.9677 29.3677 23.3323C30.3444 23.6969 31.3821 23.9399 32.5419 23.9399C33.2744 23.9399 34.0069 23.8184 34.6784 23.6361C35.4109 23.4538 36.0213 23.2107 36.6317 22.8461C37.2421 22.5423 37.7305 22.1169 38.2188 21.6308C38.7071 21.1447 39.0123 20.6585 39.2565 20.0509L39.4396 19.6255L37.3642 19.0786L37.2421 19.3824C37.059 19.747 36.8148 20.1116 36.5096 20.4155C36.2044 20.7193 35.8382 21.0231 35.4109 21.2054C34.9836 21.4485 34.5563 21.6308 34.0679 21.7523C32.8471 22.0562 31.5652 21.9954 30.5275 21.5093C29.8561 21.2054 29.3067 20.8408 28.7573 20.3547C28.1469 19.9293 27.7196 19.3824 27.3533 18.714C27.1092 18.1671 26.926 17.6202 26.804 17.0125H40.0501L40.1721 16.7695C40.2332 16.6479 40.2332 16.5264 40.2332 16.3441V15.9795C40.2942 14.8857 40.1111 13.9134 39.6838 12.9412ZM37.9746 15.0072H26.804C26.865 14.3996 27.0481 13.7919 27.2923 13.245C27.5975 12.5766 28.0248 12.0297 28.5131 11.5436C29.0015 11.0574 29.6119 10.6928 30.2834 10.4498C31.5652 9.90286 33.2134 9.90286 34.4952 10.4498C35.1667 10.6928 35.7161 11.1182 36.2655 11.5436C36.7538 12.0297 37.1811 12.5766 37.4863 13.245C37.7305 13.7919 37.9136 14.3996 37.9746 15.0072Z"
        fill="white"
      />
      <path d="M83.383 0H81.4297V24.0028H83.383V0Z" fill="white" />
      <path
        d="M7.69128 24.0641C3.41834 24.0641 0 20.6004 0 16.2859C0 11.9715 3.47939 8.50781 7.69128 8.50781C11.9032 8.50781 15.3826 11.9715 15.3826 16.2859C15.3826 20.5396 11.9642 24.0641 7.69128 24.0641Z"
        fill="#21CFD6"
      />
      <path
        d="M17.6366 15.3125H5.36719V16.9532H17.6366V15.3125Z"
        fill="white"
      />
      <path
        d="M17.7714 17.0713H5.25781V15.1875H17.7714V17.0713ZM5.50198 16.889H17.5883V15.4913H5.50198V16.889Z"
        fill="white"
      />
      <path
        d="M99.7511 8.20139V11.1182C98.2861 9.29519 95.9665 8.14062 93.4638 8.14062C89.0077 8.14062 85.4062 11.6651 85.4062 16.0403C85.4062 20.4155 89.0077 23.9399 93.4638 23.9399C96.0275 23.9399 98.2861 22.7854 99.7511 20.9624V24.1222H101.643V8.20139H99.7511ZM93.4027 10.2067C96.6379 10.2067 99.3238 12.8197 99.3238 15.9795C99.3238 19.1394 96.699 21.7523 93.4027 21.7523C90.1675 21.7523 87.5427 19.1394 87.5427 15.9795C87.5427 12.8197 90.1675 10.2067 93.4027 10.2067Z"
        fill="white"
      />
    </svg>
  ),
  folderIconSvg: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
    >
      <path
        d="M2 16C1.45 16 0.979167 15.8042 0.5875 15.4125C0.195833 15.0208 0 14.55 0 14V2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H7.175C7.44167 0 7.69583 0.05 7.9375 0.15C8.17917 0.25 8.39167 0.391667 8.575 0.575L10 2H18C18.55 2 19.0208 2.19583 19.4125 2.5875C19.8042 2.97917 20 3.45 20 4V14C20 14.55 19.8042 15.0208 19.4125 15.4125C19.0208 15.8042 18.55 16 18 16H2Z"
        fill="#757575"
      />
    </svg>
  ),
  imagePreviewIcons: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M2.30775 17.5C1.80258 17.5 1.375 17.325 1.025 16.975C0.675 16.625 0.5 16.1974 0.5 15.6923V2.30775C0.5 1.80258 0.675 1.375 1.025 1.025C1.375 0.675 1.80258 0.5 2.30775 0.5H15.6923C16.1974 0.5 16.625 0.675 16.975 1.025C17.325 1.375 17.5 1.80258 17.5 2.30775V15.6923C17.5 16.1974 17.325 16.625 16.975 16.975C16.625 17.325 16.1974 17.5 15.6923 17.5H2.30775ZM2.30775 16H15.6923C15.7692 16 15.8398 15.9679 15.9038 15.9038C15.9679 15.8398 16 15.7692 16 15.6923V2.30775C16 2.23075 15.9679 2.16025 15.9038 2.09625C15.8398 2.03208 15.7692 2 15.6923 2H2.30775C2.23075 2 2.16025 2.03208 2.09625 2.09625C2.03208 2.16025 2 2.23075 2 2.30775V15.6923C2 15.7692 2.03208 15.8398 2.09625 15.9038C2.16025 15.9679 2.23075 16 2.30775 16ZM3.75 13.75H14.3268L11.0385 9.3655L8.23075 13.0192L6.23075 10.4615L3.75 13.75Z"
        fill="#1C1B1F"
      />
    </svg>
  ),
  pdfPreviewIcons: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="16"
      viewBox="0 0 15 16"
      fill="none"
    >
      <path
        d="M13.0192 12.875H5.23081C4.85194 12.875 4.53125 12.7438 4.26875 12.4813C4.00625 12.2188 3.875 11.8981 3.875 11.5192V1.48081C3.875 1.10194 4.00625 0.78125 4.26875 0.51875C4.53125 0.25625 4.85194 0.125 5.23081 0.125H10.4375L14.375 4.0625V11.5192C14.375 11.8981 14.2438 12.2188 13.9813 12.4813C13.7188 12.7438 13.3981 12.875 13.0192 12.875ZM9.875 4.625V1.25H5.23081C5.17306 1.25 5.12019 1.27406 5.07219 1.32219C5.02406 1.37019 5 1.42306 5 1.48081V11.5192C5 11.5769 5.02406 11.6298 5.07219 11.6778C5.12019 11.7259 5.17306 11.75 5.23081 11.75H13.0192C13.0769 11.75 13.1298 11.7259 13.1778 11.6778C13.2259 11.6298 13.25 11.5769 13.25 11.5192V4.625H9.875ZM2.23081 15.875C1.85194 15.875 1.53125 15.7438 1.26875 15.4813C1.00625 15.2188 0.875 14.8981 0.875 14.5192V4.625H2V14.5192C2 14.5769 2.02406 14.6298 2.07219 14.6778C2.12019 14.7259 2.17306 14.75 2.23081 14.75H9.875V15.875H2.23081Z"
        fill="#1C1B1F"
      />
    </svg>
  ),
  videoPreviewIcon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
    >
      <path
        d="M2.30775 0.5L4.05775 4H7.05775L5.30775 0.5H7.30775L9.05775 4H12.0577L10.3077 0.5H12.3077L14.0577 4H17.0578L15.3077 0.5H17.6923C18.1974 0.5 18.625 0.675 18.975 1.025C19.325 1.375 19.5 1.80258 19.5 2.30775V13.6923C19.5 14.1974 19.325 14.625 18.975 14.975C18.625 15.325 18.1974 15.5 17.6923 15.5H2.30775C1.80258 15.5 1.375 15.325 1.025 14.975C0.675 14.625 0.5 14.1974 0.5 13.6923V2.30775C0.5 1.80258 0.675 1.375 1.025 1.025C1.375 0.675 1.80258 0.5 2.30775 0.5ZM2 5.5V13.6923C2 13.7821 2.02883 13.8558 2.0865 13.9135C2.14417 13.9712 2.21792 14 2.30775 14H17.6923C17.7821 14 17.8558 13.9712 17.9135 13.9135C17.9712 13.8558 18 13.7821 18 13.6923V5.5H2Z"
        fill="#1C1B1F"
      />
    </svg>
  ),
  otherPreviewIcon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M4.25 13.75H10.75V12.25H4.25V13.75ZM4.25 9.75H13.75V8.25H4.25V9.75ZM4.25 5.75H13.75V4.25H4.25V5.75ZM2.30775 17.5C1.80258 17.5 1.375 17.325 1.025 16.975C0.675 16.625 0.5 16.1974 0.5 15.6923V2.30775C0.5 1.80258 0.675 1.375 1.025 1.025C1.375 0.675 1.80258 0.5 2.30775 0.5H15.6923C16.1974 0.5 16.625 0.675 16.975 1.025C17.325 1.375 17.5 1.80258 17.5 2.30775V15.6923C17.5 16.1974 17.325 16.625 16.975 16.975C16.625 17.325 16.1974 17.5 15.6923 17.5H2.30775ZM2.30775 16H15.6923C15.7692 16 15.8398 15.9679 15.9038 15.9038C15.9679 15.8398 16 15.7692 16 15.6923V2.30775C16 2.23075 15.9679 2.16025 15.9038 2.09625C15.8398 2.03208 15.7692 2 15.6923 2H2.30775C2.23075 2 2.16025 2.03208 2.09625 2.09625C2.03208 2.16025 2 2.23075 2 2.30775V15.6923C2 15.7692 2.03208 15.8398 2.09625 15.9038C2.16025 15.9679 2.23075 16 2.30775 16Z"
        fill="#1C1B1F"
      />
    </svg>
  ),
  collectionPreviewIcon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="19"
      viewBox="0 0 22 19"
      fill="none"
    >
      <path
        d="M2.30775 18.3845C1.80908 18.3845 1.38308 18.2079 1.02975 17.8547C0.676583 17.5016 0.5 17.0757 0.5 16.577V4.5385H2V16.577C2 16.6667 2.02883 16.7403 2.0865 16.798C2.14417 16.8557 2.21792 16.8845 2.30775 16.8845H18.5V18.3845H2.30775ZM5.80775 14.8845C5.30892 14.8845 4.88292 14.7079 4.52975 14.3548C4.17658 14.0016 4 13.5757 4 13.077V2.30775C4 1.80908 4.17658 1.38308 4.52975 1.02975C4.88292 0.676583 5.30892 0.5 5.80775 0.5H10.7885L12.7885 2.5H19.6923C20.1909 2.5 20.6169 2.67658 20.9703 3.02975C21.3234 3.38308 21.5 3.80908 21.5 4.30775V13.077C21.5 13.5757 21.3234 14.0016 20.9703 14.3548C20.6169 14.7079 20.1909 14.8845 19.6923 14.8845H5.80775ZM8.23075 11H17.577L14.473 6.923L12.0962 9.9615L10.527 8.01925L8.23075 11Z"
        fill="#929292"
      />
    </svg>
  ),
  collectionNumberAssetSvgIcon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="22"
      viewBox="0 0 18 22"
      fill="none"
    >
      <path
        d="M16.1923 17.5H5.80775C5.30258 17.5 4.875 17.325 4.525 16.975C4.175 16.625 4 16.1974 4 15.6923V2.30775C4 1.80258 4.175 1.375 4.525 1.025C4.875 0.675 5.30258 0.5 5.80775 0.5H12.75L18 5.75V15.6923C18 16.1974 17.825 16.625 17.475 16.975C17.125 17.325 16.6974 17.5 16.1923 17.5ZM12 6.5V2H5.80775C5.73075 2 5.66025 2.03208 5.59625 2.09625C5.53208 2.16025 5.5 2.23075 5.5 2.30775V15.6923C5.5 15.7692 5.53208 15.8398 5.59625 15.9038C5.66025 15.9679 5.73075 16 5.80775 16H16.1923C16.2693 16 16.3398 15.9679 16.4038 15.9038C16.4679 15.8398 16.5 15.7692 16.5 15.6923V6.5H12ZM1.80775 21.5C1.30258 21.5 0.875 21.325 0.525 20.975C0.175 20.625 0 20.1974 0 19.6923V6.5H1.5V19.6923C1.5 19.7693 1.53208 19.8398 1.59625 19.9038C1.66025 19.9679 1.73075 20 1.80775 20H12V21.5H1.80775Z"
        fill="#929292"
      />
    </svg>
  ),
  downloadIconsSvg: (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        height: "100%",
      }}
    >
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <mask id="mask0_11625_40740" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
          <rect width="24" height="24" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_11625_40740)">
          <path d="M12 15.7885L7.73075 11.5192L8.78475 10.4348L11.25 12.9V4.5H12.75V12.9L15.2153 10.4348L16.2693 11.5192L12 15.7885ZM6.30775 19.5C5.80258 19.5 5.375 19.325 5.025 18.975C4.675 18.625 4.5 18.1974 4.5 17.6923V14.9808H6V17.6923C6 17.7693 6.03208 17.8398 6.09625 17.9038C6.16025 17.9679 6.23075 18 6.30775 18H17.6923C17.7693 18 17.8398 17.9679 17.9038 17.9038C17.9679 17.8398 18 17.7693 18 17.6923V14.9808H19.5V17.6923C19.5 18.1974 19.325 18.625 18.975 18.975C18.625 19.325 18.1974 19.5 17.6923 19.5H6.30775Z" fill="#1E293B" />
        </g>
      </svg>
    </div>
  ),
  singleIConSvg: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M8 8C6.9 8 5.95833 7.60833 5.175 6.825C4.39167 6.04167 4 5.1 4 4C4 2.9 4.39167 1.95833 5.175 1.175C5.95833 0.391667 6.9 0 8 0C9.1 0 10.0417 0.391667 10.825 1.175C11.6083 1.95833 12 2.9 12 4C12 5.1 11.6083 6.04167 10.825 6.825C10.0417 7.60833 9.1 8 8 8ZM0 14V13.2C0 12.6333 0.145833 12.1125 0.4375 11.6375C0.729167 11.1625 1.11667 10.8 1.6 10.55C2.63333 10.0333 3.68333 9.64583 4.75 9.3875C5.81667 9.12917 6.9 9 8 9C9.1 9 10.1833 9.12917 11.25 9.3875C12.3167 9.64583 13.3667 10.0333 14.4 10.55C14.8833 10.8 15.2708 11.1625 15.5625 11.6375C15.8542 12.1125 16 12.6333 16 13.2V14C16 14.55 15.8042 15.0208 15.4125 15.4125C15.0208 15.8042 14.55 16 14 16H2C1.45 16 0.979167 15.8042 0.5875 15.4125C0.195833 15.0208 0 14.55 0 14Z"
        fill="#1E293B"
      />
    </svg>
  ),
  twoPeopleIconSvg: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="16"
      viewBox="0 0 22 16"
      fill="none"
    >
      <path
        d="M0 13.2C0 12.6333 0.145833 12.1125 0.4375 11.6375C0.729167 11.1625 1.11667 10.8 1.6 10.55C2.63333 10.0333 3.68333 9.64583 4.75 9.3875C5.81667 9.12917 6.9 9 8 9C9.1 9 10.1833 9.12917 11.25 9.3875C12.3167 9.64583 13.3667 10.0333 14.4 10.55C14.8833 10.8 15.2708 11.1625 15.5625 11.6375C15.8542 12.1125 16 12.6333 16 13.2V14C16 14.55 15.8042 15.0208 15.4125 15.4125C15.0208 15.8042 14.55 16 14 16H2C1.45 16 0.979167 15.8042 0.5875 15.4125C0.195833 15.0208 0 14.55 0 14V13.2ZM17.45 16C17.6333 15.7 17.7708 15.3792 17.8625 15.0375C17.9542 14.6958 18 14.35 18 14V13C18 12.2667 17.7958 11.5625 17.3875 10.8875C16.9792 10.2125 16.4 9.63333 15.65 9.15C16.5 9.25 17.3 9.42083 18.05 9.6625C18.8 9.90417 19.5 10.2 20.15 10.55C20.75 10.8833 21.2083 11.2542 21.525 11.6625C21.8417 12.0708 22 12.5167 22 13V14C22 14.55 21.8042 15.0208 21.4125 15.4125C21.0208 15.8042 20.55 16 20 16H17.45ZM8 8C6.9 8 5.95833 7.60833 5.175 6.825C4.39167 6.04167 4 5.1 4 4C4 2.9 4.39167 1.95833 5.175 1.175C5.95833 0.391667 6.9 0 8 0C9.1 0 10.0417 0.391667 10.825 1.175C11.6083 1.95833 12 2.9 12 4C12 5.1 11.6083 6.04167 10.825 6.825C10.0417 7.60833 9.1 8 8 8ZM18 4C18 5.1 17.6083 6.04167 16.825 6.825C16.0417 7.60833 15.1 8 14 8C13.8167 8 13.5833 7.97917 13.3 7.9375C13.0167 7.89583 12.7833 7.85 12.6 7.8C13.05 7.26667 13.3958 6.675 13.6375 6.025C13.8792 5.375 14 4.7 14 4C14 3.3 13.8792 2.625 13.6375 1.975C13.3958 1.325 13.05 0.733333 12.6 0.2C12.8333 0.116667 13.0667 0.0625 13.3 0.0375C13.5333 0.0125 13.7667 0 14 0C15.1 0 16.0417 0.391667 16.825 1.175C17.6083 1.95833 18 2.9 18 4Z"
        fill="#1E293B"
      />
    </svg>
  ),
  groupIConSvg: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="16"
      viewBox="0 0 22 16"
      fill="none"
    >
      <path
        d="M0 13.2C0 12.6333 0.145833 12.1125 0.4375 11.6375C0.729167 11.1625 1.11667 10.8 1.6 10.55C2.63333 10.0333 3.68333 9.64583 4.75 9.3875C5.81667 9.12917 6.9 9 8 9C9.1 9 10.1833 9.12917 11.25 9.3875C12.3167 9.64583 13.3667 10.0333 14.4 10.55C14.8833 10.8 15.2708 11.1625 15.5625 11.6375C15.8542 12.1125 16 12.6333 16 13.2V14C16 14.55 15.8042 15.0208 15.4125 15.4125C15.0208 15.8042 14.55 16 14 16H2C1.45 16 0.979167 15.8042 0.5875 15.4125C0.195833 15.0208 0 14.55 0 14V13.2ZM17.45 16C17.6333 15.7 17.7708 15.3792 17.8625 15.0375C17.9542 14.6958 18 14.35 18 14V13C18 12.2667 17.7958 11.5625 17.3875 10.8875C16.9792 10.2125 16.4 9.63333 15.65 9.15C16.5 9.25 17.3 9.42083 18.05 9.6625C18.8 9.90417 19.5 10.2 20.15 10.55C20.75 10.8833 21.2083 11.2542 21.525 11.6625C21.8417 12.0708 22 12.5167 22 13V14C22 14.55 21.8042 15.0208 21.4125 15.4125C21.0208 15.8042 20.55 16 20 16H17.45ZM8 8C6.9 8 5.95833 7.60833 5.175 6.825C4.39167 6.04167 4 5.1 4 4C4 2.9 4.39167 1.95833 5.175 1.175C5.95833 0.391667 6.9 0 8 0C9.1 0 10.0417 0.391667 10.825 1.175C11.6083 1.95833 12 2.9 12 4C12 5.1 11.6083 6.04167 10.825 6.825C10.0417 7.60833 9.1 8 8 8ZM18 4C18 5.1 17.6083 6.04167 16.825 6.825C16.0417 7.60833 15.1 8 14 8C13.8167 8 13.5833 7.97917 13.3 7.9375C13.0167 7.89583 12.7833 7.85 12.6 7.8C13.05 7.26667 13.3958 6.675 13.6375 6.025C13.8792 5.375 14 4.7 14 4C14 3.3 13.8792 2.625 13.6375 1.975C13.3958 1.325 13.05 0.733333 12.6 0.2C12.8333 0.116667 13.0667 0.0625 13.3 0.0375C13.5333 0.0125 13.7667 0 14 0C15.1 0 16.0417 0.391667 16.825 1.175C17.6083 1.95833 18 2.9 18 4Z"
        fill="#1E293B"
      />
    </svg>
  ),
  rightArrowSvgIcon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M7.3 15.2969C7.11667 15.1135 7.02083 14.8802 7.0125 14.5969C7.00417 14.3135 7.09167 14.0802 7.275 13.8969L12.175 8.99687H1C0.716667 8.99687 0.479167 8.90104 0.2875 8.70938C0.0958333 8.51771 0 8.28021 0 7.99688C0 7.71354 0.0958333 7.47604 0.2875 7.28438C0.479167 7.09271 0.716667 6.99688 1 6.99688H12.175L7.275 2.09688C7.09167 1.91354 7.00417 1.68021 7.0125 1.39688C7.02083 1.11354 7.11667 0.880208 7.3 0.696875C7.48333 0.513542 7.71667 0.421875 8 0.421875C8.28333 0.421875 8.51667 0.513542 8.7 0.696875L15.3 7.29688C15.4 7.38021 15.4708 7.48438 15.5125 7.60938C15.5542 7.73438 15.575 7.86354 15.575 7.99688C15.575 8.13021 15.5542 8.25521 15.5125 8.37188C15.4708 8.48854 15.4 8.59688 15.3 8.69688L8.7 15.2969C8.51667 15.4802 8.28333 15.5719 8 15.5719C7.71667 15.5719 7.48333 15.4802 7.3 15.2969Z"
        fill="#757575"
      />
    </svg>
  ),
  searchIconSvg: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <g id="search" transform="translate(-236 -418)">
        <rect
          id="Path"
          width="24"
          height="24"
          transform="translate(236 418)"
          fill="rgba(0,0,0,0)"
        />
        <path
          id="Icon"
          d="M255,438.49h0l-5-4.989v-.79l-.27-.28a6.509,6.509,0,1,1,.7-.7l.28.27h.789l4.991,5-1.49,1.49ZM245.5,423a4.5,4.5,0,1,0,4.5,4.5A4.505,4.505,0,0,0,245.5,423Z"
          fill="#1d1d1d"
        />
      </g>
    </svg>
  ),
  googleLensIconSvg: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      class="Gdd5U"
      focusable="false"
      viewBox="0 0 192 192"
      width="192"
      height="192"
    >
      <rect fill="none" height="192" width="192" />
      <g>
        <circle fill="#34A853" cx="144.07" cy="144" r="16" />
        <circle fill="#4285F4" cx="96.07" cy="104" r="24" />
        <path
          fill="#EA4335"
          d="M24,135.2c0,18.11,14.69,32.8,32.8,32.8H96v-16l-40.1-0.1c-8.8,0-15.9-8.19-15.9-17.9v-18H24V135.2z"
        />
        <path
          fill="#FBBC05"
          d="M168,72.8c0-18.11-14.69-32.8-32.8-32.8H116l20,16c8.8,0,16,8.29,16,18v30h16V72.8z"
        />
        <path
          fill="#4285F4"
          d="M112,24l-32,0L68,40H56.8C38.69,40,24,54.69,24,72.8V92h16V74c0-9.71,7.2-18,16-18h80L112,24z"
        />
      </g>
    </svg>
  ),
};
